import { useState } from "react";
import axios from "axios";
import { Trash2, ShieldBan, ShieldCheck, Pin, Award, MoreVertical } from "lucide-react";
import { toast } from "sonner";

const API = "https://uttarakhand-travel-app-123.onrender.com/api";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export default function AdminControls({ post, user, onPostDeleted }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!user || user.role !== "admin") return null;

  const postId = post.id || post._id;

  const handleDeletePost = async () => {
    if (!window.confirm("Are you sure you want to delete this post?")) return;
    setLoading(true);
    try {
      await axios.delete(`${API}/posts/${postId}`, { headers: getHeaders() });
      toast.success("Post deleted");
      if (onPostDeleted) onPostDeleted(postId);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to delete post");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleBanUser = async () => {
    if (!window.confirm(`Ban ${post.author?.name}?`)) return;
    setLoading(true);
    try {
      await axios.post(`${API}/admin/user/${post.author_id}/ban`, {}, { headers: getHeaders() });
      toast.success("User banned");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to ban user");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleUnbanUser = async () => {
    if (!window.confirm(`Unban ${post.author?.name}?`)) return;
    setLoading(true);
    try {
      await axios.post(`${API}/admin/user/${post.author_id}/unban`, {}, { headers: getHeaders() });
      toast.success("User unbanned");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to unban user");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handlePinPost = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/admin/post/${postId}/pin`, {}, { headers: getHeaders() });
      toast.success("Post pinned");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to pin post");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(!open); }}
        className="p-1 rounded hover:bg-gray-100 text-gray-500"
        title="Admin Controls"
      >
        <MoreVertical className="w-4 h-4" />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-1 w-48 bg-white rounded-xl shadow-lg border border-red-100 py-1 overflow-hidden"
          onClick={(e) => e.stopPropagation()}
          style={{ zIndex: 9999 }}
        >
          <div className="px-3 py-1.5 text-xs font-bold text-red-600 bg-red-50 mb-1 border-b border-red-100 uppercase tracking-wider">
            Admin Actions
          </div>
          <button onClick={handlePinPost} disabled={loading}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <Pin className="w-4 h-4" /> Pin Post
          </button>
          <button onClick={() => toast.info("Coming soon")} disabled={loading}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2">
            <Award className="w-4 h-4" /> Give Badge
          </button>
          <button onClick={handleBanUser} disabled={loading || !post.author_id}
            className="w-full text-left px-4 py-2 text-sm text-orange-600 hover:bg-orange-50 flex items-center gap-2">
            <ShieldBan className="w-4 h-4" /> Ban Writer
          </button>
          <button onClick={handleUnbanUser} disabled={loading || !post.author_id}
            className="w-full text-left px-4 py-2 text-sm text-blue-600 hover:bg-blue-50 flex items-center gap-2">
            <ShieldCheck className="w-4 h-4" /> Unban Writer
          </button>
          <button onClick={handleDeletePost} disabled={loading}
            className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2">
            <Trash2 className="w-4 h-4" /> {loading ? "Deleting..." : "Delete Post"}
          </button>
        </div>
      )}
    </div>
  );
}
